import { Component } from "vue-property-decorator"

import FButtonToggleBase from "./fButtonToggle.client.base"

@Component
export default class FButtonToggleWeb extends FButtonToggleBase {}
